export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7994.88213d18.jpg";